import type { StudentSnapshotRow } from '../types/sinif';

function formatMsShort(ms: number) {
  const hours = Math.floor(ms / 3600000);
  const minutes = Math.round((ms % 3600000) / 60000);
  if (hours > 0) return `${hours} saat ${minutes} dakika`;
  return `${minutes} dakika`;
}

/**
 * Veli iletişim bilgisi burada YOK — bu fonksiyon sadece metin üretir.
 * İletmek öğretmenin kendi kanalıyla yapacağı ayrı bir iş.
 * Bkz. SINIF_PLATFORM_PLAN.md §4.4.
 */
export function generateParentReportText(studentName: string, snapshot: StudentSnapshotRow | null): string {
  if (!snapshot) {
    return `Merhaba, ${studentName} hakkında henüz yeterli veri yok — ilk çalışmasından sonra burada bir özet oluşturabileceğim.`;
  }

  const weakSubjects = snapshot.subject_breakdown
    .filter(sb => sb.total > 0 && sb.completed / sb.total < 0.5)
    .map(sb => sb.subject);
  const strongSubjects = snapshot.subject_breakdown
    .filter(sb => sb.total > 0 && sb.completed / sb.total >= 0.8)
    .map(sb => sb.subject);

  let text = `Merhaba, ${studentName} bu hafta ${snapshot.week_completed_videos} video tamamladı ve toplam ${formatMsShort(snapshot.week_study_ms)} çalıştı.`;

  if (strongSubjects.length > 0) {
    text += ` ${strongSubjects.join(', ')} konusunda iyi ilerliyor.`;
  }
  if (weakSubjects.length > 0) {
    text += ` ${weakSubjects.join(', ')} konusunda biraz daha pratik yapması faydalı olacak.`;
  }
  text += ' Bu tempoyu birlikte koruyalım.';

  return text;
}
